export default __webpack_public_path__ + "static/media/pokemon_ice.b15442de.png";